import { render, staticRenderFns } from "./ReflectiveJournal.vue?vue&type=template&id=059cc780&scoped=true"
import script from "./ReflectiveJournal.vue?vue&type=script&lang=js"
export * from "./ReflectiveJournal.vue?vue&type=script&lang=js"
import style0 from "./ReflectiveJournal.vue?vue&type=style&index=0&id=059cc780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059cc780",
  null
  
)

export default component.exports